<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile" id="tableDiv">
            <div v-if="!showDialogFilters"  class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <app-date-time-control-bar
                        @handleFilter="validateDataPreRequest"
                        :start_date_open_date="datePickerStartDate"
                        :end_date_open_date="datePickerEndDate"
                        :loading_historical_data="isLoadingHistoricalData"
                        :disable_calendar="selectedOrg == null"
                        :display_time="false">
                    <template v-slot:selectone>
                        <Dropdown v-model="selectedOrg" :options="organizations"
                                optionLabel="display_name" :placeholder="$t('AppFleetReport.Organizações')"
                                class="auto-center" :dataKey="'id'"
                                :filter="true"
                                style="width: 250px; margin-right: 6px;"
                                @input="saveChosenOptionsToLocalStorage"/>
                    </template>
                </app-date-time-control-bar>
            </div>
            <div v-if="showDialogFilters" class="kt-portlet__head kt-portlet__head--lg no-border-radius" style="justify-content: center;">
                <app-button v-show="showDialogFilters" type="primary" class="mx-1 auto-center" @handleClick="openMaximizable">
                    {{ $t('AppFleetReport.Filtrar') }}
                </app-button>
            </div>
            <Dialog :header="$t('AppFleetReport.Filtrar')" :visible.sync="displayMaximizable" :containerStyle="{width: '85vw'}" :maximizable="true" :modal="true">
                <app-date-time-control-bar
                        style="display: flex; justify-content: center; margin-left: 0px;" class="row col-12"
                        @handleFilter="validateDataPreRequest"
                        :start_date_open_date="datePickerStartDate"
                        :end_date_open_date="datePickerEndDate"
                        :is_col_12="true">
                    <template v-slot:selectone>
                        <div class="col-12 row" style="margin-top: 5px;">
                            <label class="col-12">{{ $t('AppFleetReport.Organização') }}</label>
                            <Dropdown v-model="selectedOrg" :options="organizations"
                                    optionLabel="display_name" :placeholder="$t('AppFleetReport.Organizações')"
                                    class="auto-center col-12" :dataKey="'id'"
                                    :filter="true"
                                    style="width: 250px"
                                    appendTo="tableDiv"
                                    @input="saveChosenOptionsToLocalStorage"/>
                        </div>
                        <div class="col-12 row" style="margin-top: 5px;">
                            <label class="col-12">{{ $t('AppFleetReport.Período') }}</label>
                        </div>
                    </template>
                </app-date-time-control-bar>
            </Dialog>
            <div class="kt-portlet__body no-padding">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" filterDisplay="row" :filters.sync="filters"
                        :sortOrder="-1" sortField="last_contact" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[10,25,50]"
                        responsiveLayout="scroll"
                        :currentPageReportTemplate="$t('AppFleetReport.currentPageReportTemplate')"
                        class="p-datatable-striped">
                        <template #header>
                            <div style="display: flex; justify-content: space-between;">
                                <span style="font-size: 20px; font-weight: 500;">{{$t('AppFleetReport.Relatório de máquinas')}}</span>
                                <Button icon="pi pi-external-link" :label="$t('AppFleetReport.Exportar')" @click="exportCsv" style="font-size: 13px;" />
                            </div>
                        </template>
                        <template #empty>
                            {{$t('AppFleetReport.Sem dados para exibir')}}
                        </template>
                        <template #loading>
                             {{$t('AppFleetReport.Carregando veículos, por favor aguarde')}}
                        </template>
                        <Column field="identification" :header="$t('AppFleetReport.Identificacao')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.identification }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="equipment_type" :header="$t('AppFleetReport.Tipo de máquina')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.equipment_type }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="equipment_model" :header="$t('AppFleetReport.Modelo de máquina')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.equipment_model }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="utilization" :header="$t('AppFleetReport.Utilização')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.utilization) }}%</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="work_time" :header="$t('AppFleetReport.Horas de Trabalho')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatTime(slotProps.data.work_time) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="productive_time" :header="$t('AppFleetReport.Horas Produtivas')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatTime(slotProps.data.productive_time) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="not_productive_time" :header="$t('AppFleetReport.Horas nao Produtivas')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatTime(slotProps.data.not_productive_time) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="consumption_total" :header="$t('AppFleetReport.Consumo Total(L/h)')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.consumption_total) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="consumption_productive" :header="$t('AppFleetReport.Consumo Produtivo(L/h)')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.consumption_productive) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="consumption" :header="$t('AppFleetReport.Combustivel(L)')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.consumption) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="total_distance" :header="$t('AppFleetReport.Distancia Total(km)')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.total_distance) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="efficiency" :header="$t('AppFleetReport.Eficiencia')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.efficiency) }}%</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="maintenance_time" :header="$t('AppFleetReport.Tempo em Manutencao')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatTime(slotProps.data.maintenance_time) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="availability" :header="$t('AppFleetReport.Disponibilidade')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.availability) }}%</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="monitoring_rate" :header="$t('AppFleetReport.Taxa de monitoramento')" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValueWithoutZero(slotProps.data.monitoring_rate) }}%</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppTable from "../../common/AppTable";
import AppButton from "../../common/AppButton";
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import ProgressBar from 'primevue/progressbar';
import Button from 'primevue/button'
import OrganizationsService from "@/services/OrganizationsService";
import VehiclesService from "@/services/VehiclesService";
import MapOverlayService from "@/services/MapOverlayService";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import MultiSelect from "primevue/multiselect";
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import AppDateTimeControlBar from "../../common/AppDateTimeControlBar";
import moment from 'moment';
import {FilterMatchMode} from 'primevue/api';
import displayToast from '@/mixins/ToastMixin';
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import formatValue from '@/mixins/ValuesFormat';
import getTimeFromSecondsDurationFormatMixin from "@/mixins/DateMixin";
import {FilterService} from 'primevue/api';
const FORMAT_TIME = 'FORMAT TIME';
const FORMAT_VALUE = 'FORMAT VALUE';

export default {
    mixins: [orderCustomFieldByNaturalOrder, displayToast, exportJsonToCsv, formatValue, getTimeFromSecondsDurationFormatMixin],
    created() {
        this.organizationsService = new OrganizationsService();
        this.vehiclesService = new VehiclesService();
        this.mapOverlayService = new MapOverlayService();
    },
    mounted: function () {
        this.getOrganizations();
        this.showDialogFilters = window.screen.width <= 1024;
        FilterService.register(FORMAT_TIME, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.formatTime(value).includes(filter);
        });
        FilterService.register(FORMAT_VALUE, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.formatValueWithoutZero(value).includes(filter);
        });
    },
    data() {
        return {
            loading: false,
            gridData: [],
            organizationsService: null,
            vehiclesService: null,
            mapOverlayService: null,
            loadingOrgs: false,
            selectedOrg: null,
            organizations: [],
            storedChosenOptions: {},
            showDialogFilters: false,
            endDate: moment().add(3, 'M'),
            datePickerStartDate: moment().subtract(1, 'day').startOf('day').toDate(),
            datePickerEndDate: moment().toDate(),
            displayMaximizable: false,
            filters: {
                'identification': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'equipment_type': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'equipment_model': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'utilization': {value: null, matchMode: FORMAT_VALUE},
                'work_time': {value: null, matchMode: FORMAT_TIME},
                'productive_time': {value: null, matchMode: FORMAT_TIME},
                'not_productive_time': {value: null, matchMode: FORMAT_TIME},
                'consumption_total': {value: null, matchMode: FORMAT_VALUE},
                'consumption_productive': {value: null, matchMode: FORMAT_VALUE},
                'consumption': {value: null, matchMode: FORMAT_VALUE},
                'total_distance': {value: null, matchMode: FORMAT_VALUE},
                'efficiency': {value: null, matchMode: FORMAT_VALUE},
                'maintenance_time': {value: null, matchMode: FORMAT_VALUE},
                'availability': {value: null, matchMode: FORMAT_VALUE},
                'monitoring_rate': {value: null, matchMode: FORMAT_VALUE}
            },
            startDateFormatted: null,
            endDateFormatted: null,
            isLoadingHistoricalData: false,
            vehicles: null
        }
    },
    methods: {
        exportCsv(){
            let csvData = [];

            let tempData = JSON.parse(JSON.stringify(this.gridData));
            tempData.forEach(data => {
                csvData.push(data);
            });

            const CSV_FIELDS = [
                'identification', 'equipment_type', 'equipment_model', 'utilization', 'work_time', 'productive_time', 'not_productive_time', 'consumption_total',
                'consumption_productive', 'consumption', 'total_distance', 'efficiency', 'maintenance_time', 'availability', 'monitoring_rate'
            ];
            const CSV_LABELS = [
                this.$t('AppFleetReport.Identificacao'), this.$t('AppFleetReport.Tipo de máquina'), this.$t('AppFleetReport.Modelo de máquina'), 
                this.$t('AppFleetReport.Utilização'), this.$t('AppFleetReport.Horas de Trabalho'), this.$t('AppFleetReport.Horas Produtivas'), 
                this.$t('AppFleetReport.Horas nao Produtivas'), this.$t('AppFleetReport.Consumo Total(L/h)'), this.$t('AppFleetReport.Consumo Produtivo(L/h)'), 
                this.$t('AppFleetReport.Combustivel(L)'), this.$t('AppFleetReport.Distancia Total(km)'), this.$t('AppFleetReport.Eficiencia'), 
                this.$t('AppFleetReport.Tempo em Manutencao'), this.$t('AppFleetReport.Disponibilidade'), this.$t('AppFleetReport.Taxa de monitoramento')
            ];

            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, `vehicle_report_${this.startDateFormatted}_${this.endDateFormatted}`);
        },
        openMaximizable() {
            this.displayMaximizable = true;
        },
        getOrganizations() {
            let vm = this;
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('VEHICLES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                vm.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppFleetReport.Operação falhou'),
                    detail: this.$t('AppFleetReport.Não foi possível buscar organizações'),
                    life: 5000
                });
                console.log(error)
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        validateDataPreRequest(data) {
            this.displayMaximizable = false;
            this.isLoadingHistoricalData = true

            if (!this.selectedOrg) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppFleetReport.Selecione uma organização'),
                    life: 3000
                });
                this.isLoadingHistoricalData = false
                return;
            }

            let start_date = moment.tz(data.start_date, 'America/Sao_Paulo').utc();
            let end_date = moment.tz(data.end_date, 'America/Sao_Paulo').utc().subtract(1, 'day');

            if (end_date.diff(start_date, 'days') > 31) {
                this.$toast.add({
                    severity: 'warn',
                    summary: this.$t('AppFleetReport.Análise não realizada'),
                    detail: this.$t('AppFleetReport.Selecione um período menor ou igual a 31 dias'),
                    life: 5000
                });
                this.isLoadingHistoricalData = false;
                return;
            }

            this.startDateFormatted = start_date.format("YYYY-MM-DD");
            this.endDateFormatted = end_date.format("YYYY-MM-DD");
            let vehiclesIds = this.vehicles ? this.vehicles.map(v => v.id) : []

            let vehicleChunks = this.chunkArray(vehiclesIds, 10)
            const promises = vehicleChunks.map(chunk => {
                let params = new URLSearchParams(); 
                chunk.forEach(v => params.append("vehicles", v));
                
                return this.mapOverlayService.getEventsDailySummary(params, this.startDateFormatted, this.endDateFormatted)
            })
            
            Promise.all(promises)
                .then(responses => {
                    let data = responses.flat()
                    data.forEach(element => {
                        let vehicle = this.vehicles ? this.vehicles.find(v => v.id === element.vid) : null
                        element.identification = vehicle ? vehicle.display_id : null
                        element.equipment_model = vehicle ? vehicle.model : null
                        element.equipment_type = vehicle ? this.$t(`VehicleType.${vehicle.type}`) : null
                    });
                    this.gridData = data
                }).catch((error) => {
                    this.gridData = []
                    this.displayToast(this.$t("AppFleetReport.Não foi possivel buscar o relatório"), 'e', error)
                }).finally(() => {
                    this.isLoadingHistoricalData = false
                })
        },
        chunkArray(array, size) {
            let result = [];
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size));
            }
            return result;
        },
        formatValueWithoutZero(val){
            return this.formatValue(val) === '0,00' ? 0 : this.formatValue(val)
        },
        formatTime(hourStr) {
            hourStr = this.formatValueWithoutZero(hourStr)
            if(!hourStr){
                return ""
            }

            let hour = parseFloat(hourStr.replace(".", "").replace(",", "."));
            return this.getTimeFromSecondsDurationFormatMixin(Math.trunc(hour * 3600));
        }
    },
    watch: {
        selectedOrg: function (val) {
            this.vehiclesService.getVehiclesByOrgV3(val.id)
                .then(data => {
                    this.vehicles = data
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 403) {
                            this.$toast.add({
                                severity: 'error',
                                summary: this.$t('AppVehicle.Você não tem acesso a esssa funcionalidade'),
                                life: 5000
                            });
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: this.$t('AppVehicle.Não foi possivel completar a operação, tente novamente'),
                                life: 5000
                            });
                        }
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicle.Não foi possivel completar a operação, tente novamente'),
                            life: 5000
                        });
                    }
                });
        }
    },
    components: {
        MultiSelect, AppTable, DataTable, Column, InputText, Calendar, Dropdown, AppDateTimeControlBar, 
        ProgressBar, Button, AppButton, Dialog, Accordion, AccordionTab
    }
}
</script>
